module.exports = __webpack_public_path__ + "media/images/iconSearch--dark-b9a2275c7663f8f0c32b4fccb53e9ba4.png";